<template>
  <div id="intro">
    <div class="backdrop">
      <div class="img-container">
        <img src="../../assets/bg-intro.png" :style=setPos alt="">
      </div>
    </div>
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide>
        <div class="slide-wrapper">
          <div class="slide-container">
            <p v-html="displayDescription1"></p>
            <button class="intro-btn btn-next"> {{ $t('intro.next') }}</button>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="slide-wrapper">
          <div class="slide-container">
            <p v-html="displayDescription2"></p>
            <button class="intro-btn btn-next"> {{ $t('intro.next') }}</button>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="slide-wrapper">
          <div class="slide-container">
            <p v-html="displayDescription3"></p>
            <button class="intro-btn"
              v-on:click="goPage('/acc/login')"> {{ $t('intro.start') }}</button>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>

</template>

<script>
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import common from '@/utils/common';

export default {
  name: 'intro',
  components: {
    swiper,
    swiperSlide,
  },
  mixins: [
    common,
  ],
  data() {
    return {
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
        },
        navigation: {
          nextEl: '.btn-next',
        },
      },

      docHeight: window.innerHeight,
      docWidth: window.innerWidth,
      displayDescription1: this.$i18n.t('intro.description1'),
      displayDescription2: this.$i18n.t('intro.description2'),
      displayDescription3: this.$i18n.t('intro.description3'),
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    setPos() {
      const docHeight = this.docHeight;
      const docWidth = this.docWidth;
      let marginValue = '';
      if (docHeight > docWidth) {
        const marginCal = (docHeight - docWidth) / 2;
        marginValue = `-${marginCal}px`;
        return {
          'margin-left': marginValue,
          width: 'auto',
          height: '100%',
        };
      }
      if (docHeight < docWidth) {
        const marginCal = (docWidth - docHeight) / 2;
        marginValue = `-${marginCal}px`;
        return {
          'margin-top': marginValue,
          width: '100%',
          height: 'auto',
        };
      }
      return {
        width: '100%',
        height: 'auto',
      };
    },
  },
  methods: {
    handleResize() {
      this.docHeight = window.innerHeight;
      this.docWidth = window.innerWidth;
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style lang="scss" src="../../scss/page-intro.scss" scoped></style>



// WEBPACK FOOTER //
// src/views/intro/Intro.vue